import { render } from "./AppLogo.vue?vue&type=template&id=15c6503e&scoped=true&ts=true"
import script from "./AppLogo.vue?vue&type=script&lang=ts"
export * from "./AppLogo.vue?vue&type=script&lang=ts"

import "./AppLogo.vue?vue&type=style&index=0&id=15c6503e&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15c6503e"]])

export default __exports__